module.exports = __webpack_public_path__ + "static/img/pxlc.929aa6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pxlc.jpg
// module id = oj/g
// module chunks = 1